import { connect } from 'react-redux';

import PRODUCT_TYPE from 'Component/Product/Product.config';
import {
    AddToCartContainer as SourceAddToCartContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/AddToCart/AddToCart.container';
import componentLoader from 'Util/componentLoader';
import { ADD_TO_CART } from 'Util/Product';
import {
    getMaxQuantity, getMinQuantity
} from 'Util/Product/Extract';
import { magentoProductTransform } from 'Util/Product/Transform';

export const CartDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
), 2);

/** @namespace Bodypwa/Component/AddToCart/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace Bodypwa/Component/AddToCart/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    fallbackAddToCart: (options) => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addProductToCart(dispatch, options)
    )
    // TODO extend mapDispatchToProps
});

/** @namespace Bodypwa/Component/AddToCart/Container */
export class AddToCartContainer extends SourceAddToCartContainer {
    containerProps() {
        const {
            isDisabled,
            isIconEnabled,
            mix,
            layout
        } = this.props;

        const {
            isAdding,
            porductBeingAdded,
            image
        } = this.state;

        return {
            isDisabled,
            isIconEnabled,
            mix,
            layout,
            isAdding,
            porductBeingAdded,
            image
        };
    }

    async addProductToCart(e) {
        const { product, addToCart } = this.props;

        if ((!product || Object.keys(product).length === 0) && !addToCart) {
            return;
        }

        e.preventDefault();
        this.setState({ isAdding: true });

        if (!this.validate()) {
            this.setState({ isAdding: false });
            return;
        }

        if (typeof addToCart === 'function') {
            try {
                this.setState({ porductBeingAdded: product, image: product.image });
                await addToCart();
            } catch (error) {
                this.setState({ isAdding: false });
            } finally {
                this.setState({ isAdding: false });
            }
        } else {
            const {
                quantity,
                cartId,
                fallbackAddToCart
            } = this.props;
            const magentoProduct = magentoProductTransform(ADD_TO_CART, product, quantity);

            try {
                this.setState({ porductBeingAdded: product, image: product.image });
                await fallbackAddToCart({
                    products: magentoProduct,
                    cartId
                });
            } catch (error) {
                this.setState({ isAdding: false });
            } finally {
                this.setState({ isAdding: false });
            }
        }
        this.setState({ isAdding: false });
    }

    validateQuantity() {
        const {
            product, quantity, showNotification, product: { type_id: typeId }
        } = this.props;
        const minQty = getMinQuantity(product);
        const maxQty = getMaxQuantity(product);
        const inRange = quantity >= minQty && quantity <= maxQty;
        const isValid = typeId === PRODUCT_TYPE.grouped || inRange;

        if (!isValid) {
            if (quantity < minQty) {
                showNotification('info', __('Sorry! Minimum quantity for this product is %s!', minQty));
            } else {
                showNotification('info', __('Sorry! Maximum quantity for this product is %s!', maxQty));
            }
        }

        return isValid;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartContainer);
